// Ordered — the first match wins, so longer/more specific markers must come
// first ('newAssetSale' before 'newAsset', '/assetSales/' before '/assets/'),
// and the editor marker must precede the containing-section marker so
// '/AdminScreen/accounts/account/:id/newContract' resolves to the contract
// editor rather than to accounts.
const ORIGIN_MARKERS = [
	{ match: ['newDebt', 'editDebt', '/debts/'], labelKey: 'action.backToDebt' },
	{ match: ['newContract', 'editContract', '/contracts/'], labelKey: 'action.backToContract' },
	{ match: ['newAssetSale', 'editAssetSale', '/assetSales/'], labelKey: 'action.backToAssetSale' },
	{ match: ['newAsset', 'editAsset', '/assets/'], labelKey: 'action.backToAsset' },
	{ match: ['newAccount', 'editAccount', '/accounts/'], labelKey: 'action.backToAccount' },
];

export const resolveOriginLabelKey = (path) => {
	if (!path) return 'action.back';
	const marker = ORIGIN_MARKERS.find(({ match }) => match.some((needle) => path.includes(needle)));
	return marker ? marker.labelKey : 'action.back';
};

// Resolved against our own origin so a crafted absolute/protocol-relative
// returnTo can't navigate off-site — only pathname+search are kept. Same
// guard the producer pages already apply (e.g. NewAccount.jsx).
export const normalizeReturnTo = (returnTo) => {
	if (!returnTo) return null;
	try {
		const target = new URL(returnTo, window.location.origin);
		return `${target.pathname}${target.search}`;
	} catch {
		return null;
	}
};
